<!-- -->
<template>
	<div class="app">
		<div class="content">
			<div class="item" v-for="(item, index) in sevenHot" :key="index">
				<div>{{index+1}}</div>
				<p>{{item.title}}</p>
			</div>
		</div>
	</div>
</template>

<script>
	//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
	//例如：import 《组件名称》 from '《组件路径》';

	export default {
		//import引入的组件需要注入到对象中才能使用
		components: {},
		props: ["sevenHot"],
		data() {
			//这里存放数据
			return {};
		},
		//监听属性 类似于data概念
		computed: {},
		//监控data中的数据变化
		watch: {},
		//方法集合
		methods: {},
		//生命周期 - 创建完成（可以访问当前this实例）
		created() {},
		//生命周期 - 挂载完成（可以访问DOM元素）
		mounted() {},
		beforeCreate() {}, //生命周期 - 创建之前
		beforeMount() {}, //生命周期 - 挂载之前
		beforeUpdate() {}, //生命周期 - 更新之前
		updated() {}, //生命周期 - 更新之后
		beforeDestroy() {}, //生命周期 - 销毁之前
		destroyed() {}, //生命周期 - 销毁完成
		activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
	};
</script>
<style  scoped>
	.item {
		height: 24px;
		width: 300px;
		display: flex;
		flex-direction: row;
		margin: 10px 0;
	}
	.item div {
		height: 24px;
		width: 24px;
		color: #ffffff;
		background-color: #808080;
		line-height: 24px;
		text-align: center;
		margin-right: 8px;
		border-radius: 4px;
	}
	.content > .item:nth-child(1) > div {
		background-color: #f03b34;
	}
	.content > .item:nth-child(2) > div {
		background-color: #fda1a2;
	}
	.content > .item:nth-child(3) > div {
		background-color: #f0a734;
	}
	.item p {
		color: #212121;
		line-height: 24px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		font-size: 14px;
		max-width: 250px;
	}
</style>


// WEBPACK FOOTER //
// src/components/sevenHot.vue